import React from "react";
import ArtworkLibrary from "../../artwork-library/ArtworkLibrary";
import { ArtworkLibraryProvider } from "../../artwork-library/context";
import styled from "styled-components";
import { DisplayClient } from "../../../types";

const LibraryPageContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

interface LibraryPageProps {
  client: DisplayClient;
}

export const LibraryPage = ({ client }: LibraryPageProps) => {
  return (
    <LibraryPageContainer>
      <ArtworkLibraryProvider
        initParents={[
          {
            parent_type: "CLIENT",
            parent_id: client.id,
          },
        ]}
        initParent={{
          parent_type: "CLIENT",
          parent_id: client.id,
        }}
        isModal={false}
        modalOpen={false}
        setModalOpen={false}
        onFileSelect={(f) => {}}
      >
        <ArtworkLibrary clientName={client.name} />
      </ArtworkLibraryProvider>
    </LibraryPageContainer>
  );
};
